import { KeyValueModel } from '@models/common';

export interface Assignments {
  roleIds: number[];
  roles: KeyValueModel<number, string>[];
  globalRoles: KeyValueModel<number, string>[];
  userId: number;
  userName: string;
  userEmail: string;
  userOrgName: string;
  allocationHoursPerMonth?: number;
  userRate?: number;
  deleting: boolean;
  edited: boolean;
  isNew: boolean;
  isPending: boolean;
}

export interface SyncUsersAndRolesModel {
  id: number;
  propagateOnHierarchy: boolean;
  users: Assignments[];
}

export interface SyncRolePositionModel {
  entityInstanceId: number;
  userId: number;
  roles: KeyValueModel<number, string>[];
}

export enum ModuleIds {
  Contract = -1,
  Project = -10,
  Program = -23,
}
